// extracted by mini-css-extract-plugin
export var section = "styles-module--section--t6t70";
export var container = "styles-module--container--xbnSH";
export var content = "styles-module--content--GWYp2";
export var title = "styles-module--title--H2-D2";
export var image = "styles-module--image--Zq1pg";
export var scaleDown = "styles-module--scaleDown--TUD2D";
export var fade = "styles-module--fade--zy0Gf";